import { render, staticRenderFns } from "./DoiCard.vue?vue&type=template&id=0b445a93&scoped=true&"
import script from "./DoiCard.vue?vue&type=script&lang=js&"
export * from "./DoiCard.vue?vue&type=script&lang=js&"
import style0 from "./DoiCard.vue?vue&type=style&index=0&id=0b445a93&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b445a93",
  null
  
)

export default component.exports